// ---------------------------------------------------------------------------
// The routes a person reaches without an account
//
// REPORTED 17 August, from a phone, out of a real outbound email: clicking the
// unsubscribe link in the footer landed on **AI SDR Login**.
//
// Every email this product sends carries that link, and the sentence next to it
// promises the recipient a way out. The page behind it is built for exactly
// that — `/optout?email=…` submits on load and needs no typing — but `optOut`
// was missing from the guard's allow-list, so the router rendered the login
// card instead. The recipient is a prospect. They have no account, they will
// never have one, and the only thing they were told they could do is the one
// thing the screen refused.
//
// It is also the promise with the shortest fuse: an unsubscribe that does not
// work is answered with a spam complaint, and complaints are charged to the
// sending domain's reputation, not to this bug.
//
// WHY THIS IS ITS OWN MODULE. The list used to be an inline `||` chain inside
// the app-shell render, where nothing could reach it — so a missing member was
// invisible until somebody clicked a link in a real email. Here it is a value a
// test can hold, and the test names the reason each member is on it.
//
// The default is CLOSED. A route not listed requires an account, which is the
// right way round: forgetting to publish a page is a bug report, forgetting to
// protect one is an incident.
// ---------------------------------------------------------------------------

/**
 * Routes served without authentication, and why each one has to be.
 *
 * Keyed by route name as registered in `sdr-router.ts` — not by path, so a
 * renamed URL cannot silently drop a page out of this list.
 */
export const PUBLIC_ROUTES: Readonly<Record<string, string>> = {
  optOut: 'Reached by prospects from the unsubscribe footer of every outbound email. They have no account.',
  connected: 'The landing page a provider redirects to after the hosted account-linking flow.',
  adminLogin: 'The form you use to obtain an admin session — requiring one to see it cannot work.',
  admin: 'Guards itself against the admin session rather than the user session.',
};

/** True when this route may be rendered without a signed-in user. */
export function isPublicRoute(routeName: string | undefined): boolean {
  return routeName !== undefined && Object.prototype.hasOwnProperty.call(PUBLIC_ROUTES, routeName);
}
